module.exports = __webpack_public_path__ + "img/icon_nodata.7b47c79b.png";